import React, { useState, useEffect, useCallback } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Image from "react-bootstrap/Image";
import Container from "react-bootstrap/Container";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { green } from "../../util/themes";
import { red } from "../../util/themes";
import { Pencil, QuestionCircle } from 'react-bootstrap-icons';
import { selectAllMenuItems, getMenu } from '../../reducers/menu'
import Spinner from "react-bootstrap/Spinner";
import { cartCount } from '../../reducers/cart';
import { isLoggedIn, getUser, logout, getSubsite } from '../../reducers/auth';
import { getAllSubsites, allSubsites } from '../../reducers/subsite';
import SwitchSiteModal from '../modals/SwitchSiteModal';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Help from "../Help";

const BACKEND_URL = process.env.REACT_APP_LOCALHOST_URL;

const IgniteNavBar = () => {
  let navigate = useNavigate();
  let location = useLocation();
  console.log("ROUTE", location);
  const dispatch = useDispatch();
  const currentUser = useSelector(getUser);
  const allSubsite = useSelector(allSubsites);
  const { isSuperAdmin, isAdmin } = useSelector(state => state.auth);
  const [content, setContent] = useState("");
  const menu = useSelector(selectAllMenuItems);
  const cartCountValue = useSelector(cartCount);
  const currentSubsite = useSelector(getSubsite);

  const loginStatus = useSelector(isLoggedIn);

  const menuStatus = useSelector(state => state.menu.status);
  const subsiteStatus = useSelector(state => state.subsite.status);

  const [siteModalShow, setSiteModalShow] = useState(false);
  const [showHelp, setShowHelp] = useState(false);

  const closeSiteModal = () => {
    setSiteModalShow(false);
  }


  useEffect(() => {
    if (isSuperAdmin && subsiteStatus === 'idle') {
      dispatch(getAllSubsites([1, 10]));
    }
  }, [isSuperAdmin, subsiteStatus, dispatch]);

  useEffect(() => {
    console.log("NAV Count UPDATED", cartCountValue);
  }, [cartCountValue]);

  let menuContent;

  if (menuStatus === 'loading') {
    menuContent = <Spinner text="Loading..." />
  } else if (menuStatus === 'succeeded') {
    console.log("MENU ADMIN", menu);
    menuContent = menu.map(menuItem => (
      <Nav.Link activeClassName="activeMenu" onClick={() => { navigate(`../productlist/${menuItem.id}`, { replace: true }); }}>{menuItem.categoryName}</Nav.Link>
    ));
  } else if (menuStatus === 'failed') {
    menuContent = <div>error</div>
  }

  const logOut = useCallback(() => {
    green();
    dispatch(logout());
  }, [dispatch]);


  const handleHelpClose = () => setShowHelp(false);
  const handleHelpShow = () => setShowHelp(true);

  return (
    <>
      <Navbar expand="lg" data-bs-theme={currentSubsite.subsite_content?.lightTheme ? "light" : "dark"} style={{ backgroundColor: currentSubsite.subsite_content?.topNavBgColor ? currentSubsite.subsite_content?.topNavBgColor : "#000000" }}>        <Container>
        <Navbar.Brand as={Link} to="/featured" >
          {process.env.REACT_APP_ENV === 'demo' &&
            <Image className="navbar-brand" src="/logo-demo.png" alt="Logo" fluid />
          }
          {process.env.REACT_APP_ENV === 'production' &&
            <Image className="navbar-brand" src="/logo.png" alt="Logo" fluid />
          }
        </Navbar.Brand>
        <Navbar.Toggle />
        <div>
          {currentUser && currentUser.subsites && (
            <>
              <img height="30" src={`${BACKEND_URL}/uploads/subsites/${currentSubsite.logoFilename}`} /><br />
              <span className="navbar-text">{currentSubsite.subsiteName}
              {currentUser.subsites.length > 1 && (
                <Pencil style={{ marginLeft: 10 }} onClick={(e) => setSiteModalShow(true)} />
              )}
</span>
            </>
          )}
        </div>
        <Navbar.Collapse className="justify-content-end">
          {loginStatus ? (
            <>
              <span className="navbar-text">Welcome<br />{currentUser.firstname + " " + currentUser.lastname}<br /><Nav.Link as={Link} to="/logout" ><span className="navbar-text">Logout</span></Nav.Link></span>
            </>
          ) : (
            <Nav.Link className="navbar-text" as={Link} to="/login" >Login</Nav.Link>
          )}
        </Navbar.Collapse>

        <QuestionCircle className="navbar-text" style={{ marginLeft: 10, width: 30, height: 30 }} onClick={handleHelpShow} />
      </Container>


      </Navbar>
      {siteModalShow && <SwitchSiteModal show={siteModalShow} closeModal={closeSiteModal} redirect="/admin/home" />}
      <Offcanvas show={showHelp} onHide={handleHelpClose} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Help</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Help route={location.pathname} />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};
export default IgniteNavBar;



